import { startOfDay } from "date-fns";
import type { BlockedDateRule } from "@/services/blockedDatesService";

export const isDateBlocked = (
  date: Date,
  materialId: string | null,
  packagingId: number | null,
  rules: BlockedDateRule[]
): boolean => {
  const dateStr = startOfDay(date).toISOString().split('T')[0];

  console.log('🔍 isDateBlocked chamado:', {
    dateStr,
    materialId,
    packagingId,
    packagingIdType: typeof packagingId,
    rulesCount: rules.length
  });

  const blocked = rules.some(rule => {
    if (rule.blocked_date !== dateStr) return false;
    
    const materialMatch = rule.material_id === null || String(rule.material_id) === String(materialId);
    const packagingMatch = rule.packaging_id === null ||
                          (packagingId !== null && Number(rule.packaging_id) === Number(packagingId));
    
    console.log('🔍 Verificando regra:', {
      ruleDate: rule.blocked_date,
      ruleMaterialId: rule.material_id,
      rulePackagingId: rule.packaging_id,
      rulePackagingIdType: typeof rule.packaging_id,
      inputMaterialId: materialId,
      inputPackagingId: packagingId,
      inputPackagingIdType: typeof packagingId,
      materialMatch,
      packagingMatch,
      willBlock: materialMatch && packagingMatch
    });
    
    return materialMatch && packagingMatch;
  });
  
  console.log('🔍 Resultado final isDateBlocked:', blocked);
  
  return blocked;
};

export const getBlockingReason = (
  date: Date,
  materialId: string | null,
  packagingId: number | null,
  rules: BlockedDateRule[]
): string | null => {
  const dateStr = startOfDay(date).toISOString().split('T')[0];

  const blockingRule = rules.find(rule => {
    if (rule.blocked_date !== dateStr) return false;
    
    const materialMatch = rule.material_id === null || String(rule.material_id) === String(materialId);
    const packagingMatch = rule.packaging_id === null ||
                          (packagingId !== null && Number(rule.packaging_id) === Number(packagingId));
    
    return materialMatch && packagingMatch;
  });

  return blockingRule?.reason || "Data/escopo bloqueado para agendamentos";
};
